import { Dropdown as SemanticDropdown } from "simplydo/react/ui";

import { FieldProps, getStringFieldOptions } from "./FieldProps";

const Dropdown = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
  assessmentIsClosed,
  isAssessment,
}: FieldProps) => {
  if (!isEditing) return <span>{String(fieldValue ?? "")}</span>;
  return (
    <SemanticDropdown
      basic
      placeholder="Options"
      clearable
      selection
      value={fieldValue as string}
      onChange={(_e, { value }) =>
        updateIdea(value as string, ["templated", field.id])
      }
      options={getStringFieldOptions(field.options).map((option, i) => ({
        key: i,
        value: option,
        text: option,
      }))}
      disabled={isAssessment && assessmentIsClosed}
    />
  );
};

export default Dropdown;
